import { useCallback, useEffect, useMemo } from 'react'

import { CursorState } from '@editor/config/constants/cursor'
import { EditorConfig } from '@editor/interfaces/editor'
import { BlueprintEditorTools } from '@editor/pages/projects/blueprint-editor/definitions'
import { RootState, useAppDispatch } from '@editor/store/app'
import { setCursor } from '@editor/store/tool'
import { useSelector } from 'react-redux'

const useEditor = (): EditorConfig => {
  // Store
  const dispatch = useAppDispatch()
  const selectedTool = useSelector((state: RootState) => state.blueprint.editor.selectedTool)
  const prevSelectedTool = useSelector((state: RootState) => state.blueprint.editor.prevSelectedTool)

  // Derived state
  const isToolSelected = useMemo(() => selectedTool === BlueprintEditorTools.TextAnnotation, [selectedTool])
  const isPreviousTool = useCallback((tool: BlueprintEditorTools) => prevSelectedTool === tool, [prevSelectedTool])

  /**
   * When user changes tools (in or out of Polyline tool), update cursor.
   */
  useEffect(() => {
    if (isToolSelected) {
      dispatch(setCursor(CursorState.CROSSHAIR))
    } else if (isPreviousTool(BlueprintEditorTools.TextAnnotation) && selectedTool !== BlueprintEditorTools.Focus) {
      dispatch(setCursor(CursorState.DEFAULT))
    }
  }, [isToolSelected, selectedTool, isPreviousTool, dispatch])

  return {
    buttons: {},
  }
}

export default useEditor
